import { Column, RightDrawer, Spacer } from '../../components';
import { logo3nUni } from '../../assets/png';
import { Svgs } from '../../assets/svg';
import { useDeviceType } from '../../hooks/useDeviceType';
import { LearnMoreDrawerProps } from './Types';
import { PackageCard } from '../components/PackageCard';
import {
  AtAGlanceSection,
  CloseButton,
  DescriptionSection,
  DrawerHeader,
  SvgBulletRow,
  YourLifeGoals,
} from './components';
import { useMemo } from 'react';

interface LearnMoreAdviceAndThreeNickelsUDrawer extends LearnMoreDrawerProps {
  freemium?: boolean;
}

const LearnMoreAdviceAndThreeNickelsUDrawer: React.FC<LearnMoreAdviceAndThreeNickelsUDrawer> = ({
  drawerOpen,
  setDrawerOpen,
  pricebookBundle,
  pricebookMetadata,
  freemium,
}) => {
  const { isMobile } = useDeviceType();
  const svgStyle = { width: '50px', height: 'auto', flexShrink: 0 };
  const bullets = useMemo(
    () => [
      <SvgBulletRow art={<Svgs.BulletCoach style={svgStyle} />} text={'PersonalizedCoaching'} />,
      freemium ? (
        <SvgBulletRow art={<Svgs.BulletPiggyBank style={svgStyle} />} text={'BudgetPlanner'} />
      ) : (
        <SvgBulletRow
          art={<Svgs.BulletInvestment style={svgStyle} />}
          text={'ObjectiveInvestmentAdvice'}
        />
      ),
      <SvgBulletRow
        art={<Svgs.BulletCalculator style={svgStyle} />}
        text={'CustomizableToolsStrong'}
      />,
      <SvgBulletRow
        art={<Svgs.BulletLessons style={svgStyle} />}
        text={'InteractiveCoursesStrong'}
      />,
    ],
    [freemium]
  );

  return (
    <RightDrawer open={drawerOpen} setOpen={setDrawerOpen}>
      <DrawerHeader
        isMobile={isMobile}
        pricebookName={pricebookBundle.pricebook.pricebookName}
        setDrawerOpen={setDrawerOpen}
        logo={logo3nUni}
        logoSize='40px'
      />

      <PackageCard pricebookBundle={pricebookBundle} pricebookMetadata={pricebookMetadata} />
      {isMobile && (
        <>
          <Spacer height='xs' />
          <Column style={{ alignItems: 'center' }}>
            <Svgs.ArtPieChart style={{ maxWidth: '115px', minWidth: '100px' }} />
          </Column>
        </>
      )}

      <Spacer height='xxs' />

      <DescriptionSection
        description='YouDontHaveToChoose'
        art={<Svgs.ArtPieChart style={{ marginLeft: '20px', marginRight: '20px' }} />}
        isMobile={isMobile}
      />

      <Spacer height={isMobile ? 'sm' : 'xxs'} />

      <AtAGlanceSection bullets={bullets} />

      <YourLifeGoals isMobile={isMobile} />

      {!isMobile && <CloseButton setDrawerOpen={setDrawerOpen} />}
      <Spacer height='xxs' />
    </RightDrawer>
  );
};

export default LearnMoreAdviceAndThreeNickelsUDrawer;
